<template>
  <div>
    <div class="charge-detail">
      <div v-if="error" class="yearTag">
        <div v-if="blackList" style="padding-bottom: 10px">
          <nut-noticebar
            :text=blackListWarn
            :scrollable="false"
          ></nut-noticebar>
        </div>
        <div v-else-if="lock" style="padding-bottom: 10px">
          <nut-noticebar
            :text=lockWarn
            :scrollable="false"
          ></nut-noticebar>
        </div>
        <div v-else-if="stopState === '报停'" style="padding-bottom: 10px">
          <nut-noticebar
            :text=stopWarn
            :scrollable="false"
          ></nut-noticebar>
        </div>
        <div v-else-if="noCharge" style="padding-bottom: 10px">
          <nut-noticebar
            :text=chargeWarn
            :scrollable="false"
          ></nut-noticebar>
        </div>
        <div v-else-if="!oldYear&&chargeState === '欠费'" style="padding-bottom: 10px">
          <nut-noticebar
            :text=oldYearWarn
            :scrollable="false"
          ></nut-noticebar>
        </div>
      </div>
      <div class="detail">
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">缴费年度</el-col>
          <el-col :span="16" class="colRight" style="color: green">{{yearTitle}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">供暖卡号</el-col>
          <el-col :span="16" class="colRight">{{cardNum}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">用户姓名</el-col>
          <el-col :span="16" class="colRight">{{userName}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">供热站</el-col>
          <el-col :span="16" class="colRight">{{heating}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">小区名称</el-col>
          <el-col :span="16" class="colRight">{{houseName}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">楼牌地址</el-col>
          <el-col :span="16" class="colRight">{{address}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">商网名称</el-col>
          <el-col :span="16" class="colRight">{{netName}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">联系电话</el-col>
          <el-col :span="16" class="colRight">{{tel}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">报停状态</el-col>
          <el-col :span="5" class="colRight" style="color: red" v-if="stopState === '报停'">{{stopState}}</el-col>
          <el-col :span="5" class="colRight" style="color: green" v-else>{{stopState}}</el-col>
          <el-col :span="5" class="colLeft" style="margin-left: 20px">缴费状态</el-col>
          <el-col :span="5" class="colRight" style="color: green">{{chargeState}}</el-col>
        </el-row>
      </div>
      <div class="detail">
        <p class="colLeft">供暖面积（平方米）</p>
        <el-row style="margin-top: 10px">
          <el-col :span="5" class="area">住宅面积</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{houseArea}}</p></el-col>
          <el-col :span="5" class="area" style="margin-left: 20px">商铺面积</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{netArea}}</p></el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="5" class="area">企业面积</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{companyArea}}</p></el-col>
          <el-col :span="5" class="area" style="margin-left: 20px">其他面积</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{otherArea}}</p></el-col>
        </el-row>
      </div>
      <div class="detail">
        <p class="colLeft">单价详情（元/平）</p>
        <el-row style="margin-top: 10px">
          <el-col :span="4" class="area">供暖开始</el-col>
          <el-col :span="6" class="colRight"><p class="floatRight">{{chargeStart}}</p></el-col>
          <el-col :span="4" class="area" style="margin-left: 20px">供暖结束</el-col>
          <el-col :span="6" class="colRight"><p class="floatRight">{{chargeEnd}}</p></el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="5" class="area">居民单价</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{userPrice}}</p></el-col>
          <el-col :span="5" class="area" style="margin-left: 20px">阁楼单价</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{housePrice}}</p></el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="5" class="area">商网单价</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{netPrice}}</p></el-col>
          <el-col :span="5" class="area" style="margin-left: 20px">企业单价</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{companyPrice}}</p></el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="5" class="area">其它单价</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight">{{otherPrice}}</p></el-col>
        </el-row>
      </div>
      <div class="chargePrice">
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">应收金额</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight" style="color: #0033CC;">{{totalPrice}}</p></el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="4" class="priceTitle">减免金额</el-col>
          <el-col :span="5" class="colRight priceLeft"><p class="floatRight" style="color: #0033CC;">{{taxPrice}}</p>
          </el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="4" class="priceTitle">滞纳金</el-col>
          <el-col :span="5" class="colRight priceLeft"><p class="floatRight" style="color: #0033CC;">
            {{revenuePrice}}</p>
          </el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="colLeft">实缴金额</el-col>
          <el-col :span="5" class="colRight"><p class="floatRight" style="color: red;">{{chargePrice}}</p></el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col :span="5" class="colLeft">缴费日期</el-col>
          <el-col :span="10" style="font-size: 15px; margin-top: 5px">{{chargeTime}}</el-col>
        </el-row>
      </div>
    </div>
    <div class="but" v-if="butState">
      <el-button style="width: 70%;" type="success" size="small" :disabled="sureChargeDis" @click="chargeRouter">缴费
      </el-button>
    </div>
    <div class="but" v-else>
      <el-button style="width: 70%;" type="success" size="small" @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'

  export default {
    name: "chargeDetail",
    data() {
      return {
        userID: this.$store.getters.getUserInfo.userID,
        openID: this.$store.getters.getUserInfo.openID,
        yearTitle: this.$route.query.yearTitle,
        cardNum: "",
        userName: "",
        heating: "",
        houseName: "",
        address: "",
        netName: "",
        tel: "",
        stopState: "",
        chargeState: "",
        houseArea: 0,// 住宅面积
        netArea: 0,// 商网面积
        companyArea: 0,// 企业面积
        otherArea: 0,// 其它面积
        totalPrice: 0.0,// 应收金额
        chargePrice: 0.0,// 实际金额
        taxPrice: 0.0,// 减免金额
        revenuePrice: 0.0,// 滞纳金
        chargeTime: "",// 缴费日期
        chargeStart: "",// 供暖开始
        chargeEnd: "",// 供暖结束
        userPrice: 0,// 用户单价
        housePrice: 0,// 阁楼单价
        netPrice: 0,// 商网单价
        companyPrice: 0,// 企业单价
        otherPrice: 0,// 其它单价
        sureChargeDis: true,// 缴费按钮是变灰
        blackList: false,// 是否显示黑名单警告
        lock: false,// 是否显示上锁警告
        noCharge: false,// 是否显示上年度未缴费警告
        oldYear: true,// 是否查看的是当前年度，不是当前年度禁止缴费
        error: false,
        blackListWarn: "您已被列入黑名单，请联系客服人员解除！",
        lockWarn: "您的账户已被上锁，请联系客服人员解除！",
        stopWarn: "您已报停，请联系客服人员！",
        chargeWarn: "您上年度未缴费，请到企业缴费！",
        oldYearWarn: "年度缴费已结束！",
        butState: this.$route.query.butState,
      }
    },
    methods: {
      getCharge() {
        let params = {
          yearData: this.yearTitle,
          clientCode: this.$route.query.cardNum
        };
        this.$http.getPayment(params).then(res => {
          if (res.state === 1) {
            let chargeDetail = res.data.row[0];
            this.cardNum = chargeDetail.clientCode;
            this.userName = chargeDetail.clientMstName;
            this.heating = chargeDetail.heatStationName;
            this.houseName = chargeDetail.housingEstateName;
            this.address = chargeDetail.housingAdd;
            this.netName = chargeDetail.clientMstSellerName;
            this.tel = chargeDetail.clientMstMobile;
            this.houseArea = chargeDetail.residentArea;
            this.netArea = chargeDetail.houseMstSellerArea;
            this.companyArea = chargeDetail.houseMstOther1Area;
            this.otherArea = chargeDetail.houseMstOther2Area;
            this.totalPrice = chargeDetail.totleAmountPrice;
            this.chargePrice = chargeDetail.clientActionPayment;
            this.taxPrice = chargeDetail.remissionPrice;
            this.revenuePrice = chargeDetail.lateFee;
            this.chargeTime = chargeDetail.updataDate;
            this.userPrice = chargeDetail.zzUnitPrice;
            this.housePrice = chargeDetail.glUnitPrice;
            this.netPrice = chargeDetail.swUnitPrice;
            this.companyPrice = chargeDetail.qQyUnitPrice;
            this.otherPrice = chargeDetail.otherUnitPrice;
            this.chargeStart = chargeDetail.heatingStartDate;
            this.chargeEnd = chargeDetail.heatingEndDate;
            this.oldYear = chargeDetail.oldYear;
            if (chargeDetail.paymentState === "1") {
              this.chargeState = "欠费"
            } else {
              this.chargeState = "已缴费"
            }
            if (chargeDetail.favorablePrecent === 1) {
              this.stopState = "报停"
            } else {
              this.stopState = "未报停"
            }
            if (chargeDetail.houseMstBlacklistFlg === "1") {
              this.blackList = true;
            }
            if (chargeDetail.paymentState === "2") {
              this.noCharge = false;
            } else if (chargeDetail.oldPaymentState === "1") {
              this.noCharge = true;
            }
            if (chargeDetail.lockFlg === "1") {
              this.lock = true;
            }
            if (this.userName !== null) {
              this.editName();
            }
            if (this.tel !== null) {
              this.editTel();
            }
            let goCharge = this.chargeState === '欠费'&&this.stopState === '未报停'&&!this.blackList&&!this.lock&&!this.noCharge&&this.oldYear
            if (goCharge) {
              this.sureChargeDis = false;
              // if (this.stopState === "报停" || this.blackList || this.lock || this.noCharge || this.chargeState === "已缴费" || !this.oldYear) {
              //   this.sureChargeDis = true;
              // }
            }

            if (this.stopState === "报停" || this.blackList || this.lock || this.noCharge || (!this.oldYear && this.chargeState === '欠费')) {
              this.error = true
            }
          } else {
            Toast({
              message: '服务器繁忙请稍后再试',
              duration: 2000
            })
          }

        })
      },

      chargeRouter() {
        this.$router.push({
          path: "/sure-charge",
          query: {yearTitle: this.yearTitle, cardNum: this.cardNum}
        })
      },

      goBack() {
        this.$router.go(-1);
      },

      editName() {
        this.userName = '**' + this.userName.substr(-1)
      },

      editTel() {
        this.tel = this.tel.replace(/(\d{3})\d{5}(\d{3})/, "$1*****$2")
      },

    },
    mounted() {
      this.getCharge();
    }
  }
</script>

<style scoped>
  /*标题字体 15px*/
  /*内容字体13px*/

  .charge-detail {
    position: absolute;
    width: 100%;
    height: 90%;
    top: 0;
    left: 0;
    overflow-y: auto;
  }

  .yearTag {
    text-align: center;
    border-bottom: 1px solid #F2F6FC;
    margin-top: 10px;
  }

  .detail {
    margin-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #F2F6FC;
  }

  .colLeft {
    margin-top: 5px;
    font-size: 15px;
    font-weight: 800;
    margin-left: 20px;
  }

  .colRight {
    background-color: #DCDEE3;
    border-radius: 4px;
    padding: 5px;
    font-size: 13px;
    height: 27px;
  }

  .floatRight {
    float: right;
  }

  .area {
    font-size: 13px;
    margin-top: 5px;
    margin-left: 20px;
  }

  .priceTitle {
    margin-top: 5px;
    font-size: 13px;
    margin-left: 30px;
  }

  .priceLeft {
    margin-left: 5px;
  }

  .chargePrice {
    margin-bottom: 10px;
  }

  .but {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 32px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
    background-color: #fff;
  }

</style>
<style>
  .el-button--success.is-disabled, .el-button--success.is-disabled:active, .el-button--success.is-disabled:focus, .el-button--success.is-disabled:hover {
    color: #FFF;
    background-color: #E0F3D8;
    border-color: #E0F3D8;
  }
</style>



// WEBPACK FOOTER //
// src/pages/chargeDetail.vue